import { z } from 'zod';
import { mcpMaterialReviewLandingPageSchema } from './mcp-material-review.js';
export const PROJECT_LANDING_PUBLICATION_VERSION = 'rw-project-landing-publication-v1';
export const projectLandingHostKeySchema = z
    .string()
    .regex(/^p-[a-f0-9]{32}$/u, 'Landing host key must contain 128 bits of lowercase hex entropy');
export const publicProjectLandingPathSchema = z
    .object({ hostKey: projectLandingHostKeySchema })
    .strict();
const artifactReferenceSchema = z
    .object({ artifactId: z.uuid(), artifactVersion: z.number().int().positive() })
    .strict();
export const createProjectLandingPublicationInputSchema = z
    .object({
    sourceCreatives: artifactReferenceSchema,
    directionId: z.string().trim().min(1).max(100),
    clientRequestId: z.uuid(),
    confirmation: z.literal('publish_verified_project_landing'),
})
    .strict();
export const projectLandingPublicationReceiptSchema = z
    .object({
    methodologyVersion: z.literal(PROJECT_LANDING_PUBLICATION_VERSION),
    id: z.uuid(),
    sourceCreatives: artifactReferenceSchema,
    directionId: z.string().trim().min(1).max(100),
    hostKey: projectLandingHostKeySchema,
    publicUrl: z.url({ protocol: /^https$/ }),
    snapshotSha256: z.string().regex(/^[a-f0-9]{64}$/u),
    status: z.enum(['active', 'revoked']),
    publishedAt: z.iso.datetime({ offset: true }),
})
    .strict();
const landingContentSchema = mcpMaterialReviewLandingPageSchema.shape.content;
export const publicProjectLandingPageSchema = z
    .object({
    kind: z.literal('project-landing-page'),
    schemaVersion: z.literal(1),
    hostKey: projectLandingHostKeySchema,
    business: z
        .object({
        name: z.string().trim().min(1).max(200),
        verifiedWebsiteUrl: z.url({ protocol: /^https?$/ }),
    })
        .strict(),
    direction: z
        .object({
        title: z.string().trim().min(1).max(300),
        locales: mcpMaterialReviewLandingPageSchema.shape.locales,
        content: landingContentSchema,
    })
        .strict(),
    form: z
        .object({
        fields: z.tuple([z.literal('name'), z.literal('contact')]),
        consentRequired: z.literal(true),
        paymentFieldsPresent: z.literal(false),
    })
        .strict(),
    publishedAt: z.iso.datetime({ offset: true }),
})
    .strict();
export const publicProjectLandingAttributionSchema = z
    .object({
    utmSource: z.string().trim().min(1).max(200).nullable().default(null),
    utmMedium: z.string().trim().min(1).max(200).nullable().default(null),
    utmCampaign: z.string().trim().min(1).max(200).nullable().default(null),
    utmContent: z.string().trim().min(1).max(200).nullable().default(null),
    utmTerm: z.string().trim().min(1).max(200).nullable().default(null),
    yclid: z.string().trim().min(1).max(500).nullable().default(null),
    referrer: z
        .url({ protocol: /^https?$/ })
        .nullable()
        .default(null),
})
    .strict();
export const submitPublicProjectLandingLeadInputSchema = z
    .object({
    clientRequestId: z.uuid(),
    name: z.string().trim().min(1).max(200).nullable().default(null),
    contact: z.string().trim().min(3).max(500),
    consent: z.literal(true),
    attribution: publicProjectLandingAttributionSchema.default(() => publicProjectLandingAttributionSchema.parse({})),
    website: z.string().max(200).default(''),
})
    .strict();
export const publicProjectLandingLeadReceiptSchema = z
    .object({
    submissionId: z.uuid(),
    receivedAt: z.iso.datetime({ offset: true }),
    status: z.literal('stored'),
})
    .strict();
//# sourceMappingURL=project-landing-publication.js.map